import * as React from "react"
import { WidgetTourStepType } from "../../types"
import { MessageIcon, PlusIcon, PointerIcon, VideoPointerIcon } from "./icons"

interface IProps {
  onAddClick: (type: WidgetTourStepType) => void
}

interface IOption {
  type: WidgetTourStepType
  label: string
  icon: React.ReactNode
}

const OPTIONS: IOption[] = [
  { type: WidgetTourStepType.POST, label: "Add post", icon: <MessageIcon /> },
  { type: WidgetTourStepType.POINTER, label: "Add pointer", icon: <PointerIcon /> },
  { type: WidgetTourStepType.VIDEO_POINTER, label: "Add video pointer", icon: <VideoPointerIcon /> },
]

const AddStepButton = ({ onAddClick }: IProps) => {
  const [hoveredType, setHoveredType] = React.useState<WidgetTourStepType | null>(null)
  const hoveredOption = OPTIONS.find((option) => option.type === hoveredType)

  return (
    <div className="bizzey-tb-add-step">
      <span className="bizzey-tb-add-step__default">
        <PlusIcon />
      </span>

      <div className="bizzey-tb-add-step__options">
        <div className="bizzey-tb-add-step__options-row">
          {OPTIONS.map((option) => (
            <button
              key={option.type}
              type="button"
              className={[
                "bizzey-tb-add-step__option",
                hoveredType === option.type ? "bizzey-tb-add-step__option--hover" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => onAddClick(option.type)}
              onMouseEnter={() => setHoveredType(option.type)}
              onMouseLeave={() => setHoveredType(null)}
              onFocus={() => setHoveredType(option.type)}
              onBlur={() => setHoveredType(null)}
              aria-label={option.label}
            >
              {option.icon}
            </button>
          ))}
        </div>
        <span className="bizzey-tb-add-step__label">{hoveredOption?.label}</span>
      </div>
    </div>
  )
}

export default AddStepButton
